module.exports = __webpack_public_path__ + "static/8-c43b9896a0cb63b354c63a1cdf09a1dc.jpg";